<template>
	<div class="quantityFilter">
		<AliareInput
			labelText="Qnt. Mínima"
			v-model="qtdMin"
			type="number"
		/>

		<AliareInput
			labelText="Qnt. Máxima"
			v-model="qtdMax"
			type="number"
		/>

		<ModalButtonSuccess
			v-show="applyButton"
			width="150"
			:titleButton="$locale.baseText('quantityFilter.apply')"
			:active="!!qtdMin && !!qtdMax"
			@click="applyFilter"
		/>

		<ModalButtonSuccess
			class="clearButton"
			v-show="clearButton"
			width="150"
			:titleButton="$locale.baseText('quantityFilter.clear')"
			:active="true"
			:shovelIcon="true"
			@click="clearFilter"
		/>
	</div>
</template>

<script>
import mixins from 'vue-typed-mixins';
import { restApi } from '@/components/mixins/restApi';

import ModalButtonSuccess from '@/components/ModalButtonSuccess.vue';
import AliareInput from '@/components/AliareInput.vue';

export default mixins(
	restApi,
).extend({
	name: "QuantityFilter",
	components: {
		ModalButtonSuccess,
		AliareInput,
	},
	props: {
		clearInput: Boolean,
	},
	data() {
		return {
			qtdMin: '1',
			qtdMax: '',
			clearButton: false,
			applyButton: true,
		};
	},

	methods:{
		applyFilter() {
			this.$emit('filterTable', this.qtdMin, this.qtdMax);
			this.applyButton =  false;
			this.clearButton = true;
		},
		clearFilter() {
			this.qtdMin = '1';
			this.qtdMax = '';
			this.applyButton =  true;
			this.clearButton = false;
			this.$emit('clearFilter');
		},
	},
	watch: {
    clearInput(newValue) {
			if (newValue !== true){
				 this.clearFilter();
			}
    },
  },
});
</script>

<style scoped lang="scss">
.quantityFilter {
	position: absolute;
	top: 54px;
	right: 10px;
	display: flex;
	width: 184px;
	flex-direction: column;
	row-gap: 20px;
	background: #1C2638;
	border: 1px solid #4A638F;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.32);
	border-radius: 4px;
	padding: 17px;
}

.clearButton {
	background: #FF495F;
	color: white;
}
</style>
